import { z } from 'zod';
import {
  pediatricHistorySchema,
  pediatricVisitSchema,
  type PediatricHistory,
  type PediatricVisit,
} from '../pediatric/assessment.js';

/**
 * Bilan pédiatrique d'une consultation — contrat réseau.
 *
 * Un `PUT` remplace le bilan entier : c'est un formulaire d'un seul tenant, et une écriture
 * partielle d'un document imbriqué obligerait à décider champ par champ ce que « absent » veut
 * dire. Un champ absent est un champ vide.
 */
export const pediatricAssessmentPutSchema = z
  .object({
    history: pediatricHistorySchema,
    visit: pediatricVisitSchema,
  })
  .strict();
export type PediatricAssessmentInput = z.infer<typeof pediatricAssessmentPutSchema>;

export interface PediatricAssessmentDto {
  encounterId: string;
  history: PediatricHistory;
  visit: PediatricVisit;
  updatedAt: string;
}

/**
 * Antécédents repris d'une consultation antérieure du même patient : seulement les modules A et B.
 * Les observations de visite ne se reprennent jamais — comme en V1.
 */
export interface PediatricInheritedHistoryDto {
  encounterId: string;
  startedAt: string;
  history: PediatricHistory;
}

export interface PediatricAssessmentResponseDto {
  /** Le bilan de cette consultation, s'il a été enregistré. */
  assessment: PediatricAssessmentDto | null;
  /** Rempli seulement quand `assessment` est nul : la consultation antérieure la plus proche. */
  inherited: PediatricInheritedHistoryDto | null;
}
